<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="小程序名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="20"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入小程序名称(限制20个字)' },
                ],
              },
            ]"
            placeholder="请输入小程序名称"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="唯一标识"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="30"
            v-decorator="[
              'xcxFlag',
              { rules: [{ required: true, message: '请输入唯一标识' }] },
            ]"
            placeholder="请输入唯一标识"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="appID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="50"
            v-decorator="[
              'appid',
              { rules: [{ required: true, message: '请输入AppId' }] },
            ]"
            placeholder="请输入AppId"
          ></a-input>
        </a-form-item>
        <a-form-item label="公钥" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="textarea"
            v-decorator="[
              'publicKey',
              { rules: [{ required: true, message: '请输入公钥' }] },
            ]"
            placeholder="请输入公钥"
          ></a-input>
        </a-form-item>
        <a-form-item label="私钥" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="textarea"
            v-decorator="[
              'privateKey',
              { rules: [{ required: true, message: '请输入私钥' }] },
            ]"
            placeholder="请输入私钥"
          ></a-input>
        </a-form-item>
        <!-- 关联页面 -->
        <a-form-item
          label="关联页面"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'pageId',
              { rules: [{ required: true, message: '请选择页面' }] },
            ]"
            @change="pageModuleHandle"
            placeholder="请选择页面"
          >
            <a-select-option
              v-for="(item, index) in pageModuleList"
              :value="item.id"
              :key="index"
              >{{ item.pageName }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction, getAction } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JDisabledDate from '@/components/jeecg/JDisabledDate';
import moment from 'moment';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';

export default {
  name: 'XcxManageModal',
  components: {
    JDate,
    JDisabledDate,
    JMultiSelectTag,
  },
  data() {
    return {
      pageModuleList: [],
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/xcxManage/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/xcxManage/edit',
        getPageModuleList:
          process.env.VUE_APP_CMS_MARKETING + '/page/modules/all',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.pageModuleHandle();
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'xcxFlag',
            'appid',
            'publicKey',
            'privateKey',
            'pageId'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'xcxFlag',
          'appid',
          'publicKey',
          'privateKey',
          'pageId'
        )
      );
    },

    disabledDate(current) {
      //return current && current < moment().endOf('day');//当天之前的不可选，包括当天
      return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
    },
    pageModuleHandle() {
      this.pageModuleList = [];
      this.getPageModuleList();
    },
    getPageModuleList() {
      getAction(this.url.getPageModuleList, {}).then((res) => {
        if (res.success) {
          this.pageModuleList = res.result;
        }
      });
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}